import Form from "ui/customers/edit-form";
import Breadcrumbs from "ui/customers/breadcrumbs";
import StepProgressbar from "ui/customers/step-progressbar";
import TopNav from "ui/dashboard/topnav";
import { useParams } from "react-router-dom";
import useSWR from "swr";
import { AuthContext } from "context/AuthContext";
import { useContext } from "react";
import { fetchWithParams } from "lib/fetcher";

export default function Page() {
  const { orgid } = useParams();
  const orgId = orgid!;
  // const [searchParams] = useSearchParams();
  // const query = searchParams.get('query') || '';
  // const currentPage = Number(searchParams.get('page')) || 1;

  const { user } = useContext(AuthContext);
  const { data, error, isLoading } = useSWR(
    [`/user/customers/${orgId}`, user.token],
    ([url, token]) => fetchWithParams(url, token),
  );

  if (isLoading) return <div>Loading...</div>;
  if (!data) {
    throw new Error(error);
  }

  return (
    <>
      <Form objCustomer={data} />
    </>
  );
}
